import { FunctionComponent, memo } from 'react';
import { StoryCardVideoContent } from '../../../services';
import { FeedCardContentCommon, FeedCardProps, FeedCardVideoCommon } from '../../../shared';

export const FeedCardVideo: FunctionComponent<FeedCardProps> = memo((props) => {
  const { card, chatId } = props;
  const {
    storyId,
    id,
    type,
    content,
    isPinnedToTopOfNewsFeed,
    isPinnedToTopOfStory,
    mentionedUsers,
  } = card;

  const { sourceName, headline, subHeadline, text, textHTML } = content as StoryCardVideoContent;

  return (
    <FeedCardContentCommon
      type={type}
      isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
      isPinnedToTopOfStory={isPinnedToTopOfStory}
      storyId={storyId}
      cardId={id}
      chatId={chatId}
      source={sourceName}
      title={headline}
      media={<FeedCardVideoCommon {...props} />}
      subTitle={subHeadline}
      text={text}
      htmlText={textHTML}
      mentionedUsers={mentionedUsers}
    />
  );
});
